<section *ngIf="data" class="onboarding-panel" #panelEl>
  <div class="onboarding-panel__content">
    <h2 *ngIf="data.title" class="onboarding-panel__title" #titleEl>
      {{ data.title.value }}
    </h2>
    <h3 *ngIf="data.subtitle" class="onboarding-panel__subtitle" #subtitleEl>
      {{ data.subtitle.value }}
    </h3>

    <div class="onboarding-panel__cards-wrapper" #wrapperEl>
      <ngx-simplebar #scrollEl [options]="scrollBarOptions" class="simplebar-custom">
        <ul *ngIf="data?.items?.value" class="onboarding-panel__cards">
          <li
            *ngFor="let item of data.items.value"
            [class.focused-onboarding]="item.focused?.value"
            class="onboarding-panel__card"
          >
            <app-onboarding-panel-card
              [data]="item"
            ></app-onboarding-panel-card>
          </li>
        </ul>
      </ngx-simplebar>
    </div>
  </div>
</section>
